import React, { Component } from 'react';
import './HomeAppDescription.scss';

class HomeAppDescription extends Component {

    constructor(props) {
        super(props);
        this.state = {}
    };

    render() {
        return (
            <div className='home-app-description'>
              <div className='container'>
                <div className='row'>
                  <div className='col-sm-6'>
                    <img src={'assets/surface.png'} width='100%' alt=""/>
                  </div>
                  <div className='col-sm-6'>
                    <h2 className='m-b-md'>Professional Quotes, Invoices & Receipts</h2>
                    <h4 className='m-t-sm hidden'>At the </h4>
                    <p>{this.props.description}</p>
                  </div>
                </div>
              </div>
            </div>
        )
    }
}

export default HomeAppDescription;



// WEBPACK FOOTER //
// ./src/views/pages/Home2/HomeAppDescription/index.js